<template>
    <div class="wide-account">
        <div class="wrapper">
            <div class="row header">
                <h1 v-if="!isMobile">Личный кабинет</h1>
                <div class="logout-line" v-if="!isMobile">
                    <div class="logout-container" @click="signOut">
                        <span class="logout-icon dont-hide-img"></span>
                        <span class="logout-text">Выйти из профиля</span>
                    </div>
                </div>
            </div>
            <div class="row display">
                <div class="padding-top-null" v-if="!isMobile">
                    <ParticipantProfile class="profile-wrapper" :user="getUser" edit />
                    <div class="grid margin-achievements">
                        <div>
                            <Folder class="no-header" title="" :is-folded-default="false" :expandable="false">
                                <router-link :to="{ name: 'account-achievements' }" class="profile-block">
                                    <img
                                        class="profile-block__image profile-block__image--awards"
                                        data-a11y="false"
                                        src="@/assets/images/account/awards.svg"
                                        alt="Достижения"
                                    />
                                    Достижения
                                </router-link>
                            </Folder>
                        </div>
                        <div>
                            <Folder class="no-header" title="" :expandable="false">
                                <router-link :to="{ name: 'account-reporting' }" class="profile-block">
                                    <img
                                        class="profile-block__image profile-block__image--reporting"
                                        data-a11y="false"
                                        src="@/assets/images/account/reporting.svg"
                                        alt="Персональные отчеты"
                                    />
                                    Персональные отчеты
                                </router-link>
                            </Folder>
                        </div>
                    </div>
                    <!-- <Folder
                        class="folder"
                        title="Календарь активностей"
                        :is-folded-default="true"
                    >
                        <Calendar />
                    </Folder> -->
                </div>
                <div class="padding-top-null profile__tabs-container" :class="{ 'col-100': isMobile }">
                    <Tabs
                        v-if="!isMobile"
                        :activeField="tabActiveField"
                        :isBgMode="true"
                        :stub="false"
                        @change-field="setField"
                        :slotsHeaders="
                            tabs.map((elem) => {
                                return {
                                    title: elem.title,
                                    bullet: elem.bullet,
                                };
                            })
                        "
                    />
                    <TabsMenu
                        v-if="isMobile && !isMobileApp"
                        class="tabs-menu-block"
                        :activeField="menuActiveField"
                        :isBgMode="true"
                        @change-field="(index) => $router.push({ name: mobileMenu[index].name })"
                        :slotsHeaders="
                            mobileMenu.map((elem) => {
                                return {
                                    title: elem.title,
                                    bullet: elem.bullet,
                                };
                            })
                        "
                    />
                    <div
                        v-if="$route.meta.section === $options.section_extra"
                        class="crumbs crumbs-desktop"
                        style="font-weight: 600"
                    >
                        <router-link :to="{ name: 'account-more' }">Еще</router-link>
                        <span>/</span>
                        <span class="title">{{ $route.meta.title }}</span>
                    </div>
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { securityService } from '@/tools/sequrity_service';

import Tabs from '@/components/UI/Tabs';
import TabsMenu from '@/components/UI/TabsMenu';
// import Calendar from '@/components/calendar/Calendar';
import Folder from '@/components/UI/Folder';
import ParticipantProfile from '@/components/participants/ParticipantProfile';

const getters = ['user', 'isMobile', 'isMobileApp'];
const usersGetters = ['getUser'];
const usersActions = ['loadFullUserById'];

import routes, { section_basic, section_extra } from '@/routes/account-tabs';
import Reporting from '@/components/account/tabs/tab-main/Reporting.vue';

export default {
    name: 'WideAccount',
    section_extra,
    components: {
        Tabs,
        TabsMenu,
        // Calendar,
        Folder,
        ParticipantProfile,
    },
    data() {
        return {
            userFields: [
                'id',
                'userId',
                'avatar',
                'name',
                'age',
                'address',
                'activity',
                'about',
                'vk',
                'ok',
                'instagram',
                'fb',
                'yt',
                'tiktok',
                'zen',
                'telegram',
                'rutube',
                'yappy',
                'tenchat',
                'gender',
                'status',
                'tel',
                'email',
                'educationLevel',
                'educationPlace',
                'address',
                'educationDuration',
                'specialty',
                'qualification',
                'educationDegree',
                'institute',
                'position',
                'instituteAddress',
                'activityPeriod',
                'instituteSite',
                'responsibilities',
                'volunteer',
                'socialWorks',
                'surname',
            ],
        };
    },
    computed: {
        ...mapGetters(getters),
        ...mapGetters('newUsers', usersGetters),
        svRole() {
            //check for user role
            //ROLE_SUPERVISOR
            const supervisors = [21, 445, 551];
            return supervisors.includes(+this.user.id);
        },
        tabActiveField() {
            let idx = this.tabs.findIndex((tab) => {
                return tab.name === this.$route.name;
            });
            return idx > -1 ? idx : this.tabs.length - 1;
        },
        menuActiveField() {
            let idx = this.mobileMenu.findIndex((tab) => {
                return tab.name === this.$route.name;
            });
            return idx > -1 ? idx : this.mobileMenu.length - 1;
        },
        tabs() {
            return routes()
                .filter((v) => v.meta)
                .filter((v) => v.meta.section === section_basic)
                .filter((v) => !v.meta.canView || v.meta.canView())
                .map((v) => ({
                    name: v.name,
                    title: v.meta.title,
                }));
        },
        mobileMenu() {
            return routes()
                .filter((v) => v.meta)
                .filter((v) => !v.meta.canView || v.meta.canView())
                .map((v) => ({
                    name: v.name,
                    title: v.meta.title,
                    icon: v.meta.icon,
                }));
        },
    },
    async mounted() {
        await this.loadFullUserById(this.user.id);
        await this.$store.dispatch('mentoring/loadGroup');
    },
    methods: {
        ...mapActions('newUsers', usersActions),
        setField(index) {
            this.$router.push({ name: this.tabs[index].name });
        },
        signOut() {
            securityService.signOut();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.wide-account {
    color: #2a2626;
    display: flex;
    justify-content: center;
    margin-bottom: rem(80);

    * {
        font-family: Montserrat, sans-serif !important;
    }

    .wrapper {
        width: 100%;

        @include on-desktop {
            margin-left: auto;
            margin-right: auto;
            max-width: rem(1608);
        }
    }

    .col-2 {
        width: 50%;
        display: inline-block;
        padding-right: rem(32);
        &:last-child {
            padding-right: 0;
        }
    }

    .row {
        width: 100%;
    }

    .padding-left-null {
        padding-left: 0;
    }

    .padding-right-null {
        padding-right: 0;
    }

    .padding-top-null {
        padding-top: 0;
    }

    .display {
        @include on-desktop {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: rem(32);
        }
    }

    .bg {
        width: 100%;
        padding: 1rem;
        background: #ffffff;
        box-shadow: 0 6px 10px rgba(131, 134, 163, 0.12);
        border-radius: rem(4);
    }

    .folder {
        margin: 0;
    }
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin: rem(40) 0 rem(40) 0;

    h1 {
        margin: 0;
        font-size: rem(34);
        line-height: rem(44);
    }

    .logout-line {
        border-bottom: rem(1) solid #ef627d;
        padding-bottom: rem(4);

        * {
            color: #ef627d;
            font-size: rem(12);
        }

        .logout-container {
            cursor: pointer;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;
        }

        .logout-icon {
            width: rem(16);
            height: rem(16);
            background: url('~@/assets/images/logout.png') no-repeat center/contain;
        }

        .logout-text {
            margin-left: rem(11);
            line-height: rem(15);
        }
    }
}

.wait {
    height: 50rem;
}

.svLink {
    margin-top: -2rem;
    padding: 1rem 0;

    a {
        color: #4663ab;
    }
}

@import '~@/styles/variables';
@media (max-width: $vm) {
    .svLink {
        margin-top: 0;
        padding: 0;

        a {
            color: #4663ab;
        }
    }
    .wide-account {
        margin-bottom: mrem(32);

        .wrapper {
            width: 100%;
            //margin-top: 10rem;
        }
    }

    .header {
        margin-top: 0;
        margin-bottom: 0;

        .logout-line {
            border-bottom: mrem(1) solid rgba(239, 98, 125, 0.3);

            * {
                color: #ef627d;
                font-family: 'Proxima Nova', sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: mrem(12);
            }

            span {
                margin-left: rem(10);
            }
        }
    }

    .tab-container {
        margin-top: mrem(16);
    }
}

.crumbs {
    margin-bottom: 10px;

    &.crumbs-mobile {
        display: none;
    }

    @include on-mobile {
        margin-top: 5rem;
        padding-left: 10px;
        &.crumbs-mobile {
            display: block;
        }
        &.crumbs-desktop {
            display: none;
        }
    }

    a:first-child {
        cursor: pointer;
        font-weight: 600;
        font-size: rem(14);
        color: #98a0a9;
    }

    a:first-child:hover {
        text-decoration: underline;
    }

    a,
    span {
        margin: 0 5px;
        color: #2a2626;
        font-size: 0.8rem;

        @include on-mobile {
            font-size: 5rem;
        }
    }

    .title {
        color: #2a2626;
    }
}

.profile-wrapper {
    width: 100%;
    padding: 1.4rem;
    background: #ffffff;
    box-shadow: 0 0.3rem 0.5rem rgba(131, 134, 163, 0.12);
    border-radius: rem(10);

    @include on-desktop {
        width: urem(788);
    } 
}
.grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: mrem(32);
    @include on-desktop {
        gap: rem(32);
    }
}

.profile {
    &__tabs-container {
        @include on-desktop {
            width: urem(787);
        }
    }
}

.margin-achievements {
    @include on-desktop {
        margin: rem(26) 0 rem(22);
    }
}
.no-header {
    border-radius: rem(10);
    :deep(header) {
        display: none;
    }
    :deep(footer) {
        padding: 0 mrem(32);
        display: flex;
        align-items: center;
        height: mrem(90);

        .profile-block {
            font-family: Montserrat, sans-serif;
            font-size: mrem(16);
            font-style: normal;
            font-weight: 700;
            line-height: mrem(52);
            display: flex;
            align-items: center;
            gap: urem(12);

            @include on-desktop {
                font-size: rem(16);
                line-height: rem(52);
            }

            &__image {
                &--awards {
                    height: mrem(52);
                    @include on-desktop {
                        height: rem(52);
                    }
                }
                &--reporting {
                    height: mrem(44);
                    @include on-desktop {
                        height: rem(44);
                    }
                }
            }
        }
        @include on-desktop {
            padding: rem(20) rem(32);
            height: rem(90);
        }
    }
}
</style>
